import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import Searchmenu from '../Components/SearchMenu'

export default function Search() {
  return (
    <>
    <Navbar/>
    <Searchmenu/>
    <Footer/>
    </>
  )
}
